module.exports = "/assets/packs/images/6d0d755835112d8ee437a5e5e1118c71.png";